module.exports = __webpack_public_path__ + "img/classroom_5.1ce5ad4d.jpg";